import { diet_plan } from "../../js/path";
import _ from "lodash";

export default {
  data() {
    return {
      pageNo: null,
      table_header: [],
      diet_plan_id: null,
      loadingId: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Patient name",
        },
        {
          key: "doctor_name",
          label: "Doctor Name",
        },
        {
          key: "order_id",
          label: "Order Id",
        },
        {
          key: "status",
          label: "Diet Plan Status",
        },
        {
          key: "gen_plan_status",
          label: "Action",
        },
        {
          key: "edit",
        },
        {
          key: "is_approved",
          label: "Approved Status",
        },
      ],
      oldForm: {},
      form: {
        html: "",
      },
      params: "",
      filter: null,
      filterOn: [],
      tableData: [],
      sortBy: "id",
      sortDesc: true,
      key: 0,
      activeTab: "all",
      currentPage: 1,
      firstLoad: false,
      isEditingPreview: false,
      selectedFiles: [],
      imageFiles: [],
      pdfFiles: [],
      chatList: [],
    };
  },
  methods: {
    search(event) {
      if (this.filter.length > 1) {
        if (event.keyCode == 13) {
          this.fetchData(this.activeTab);
        }
      } else if (this.filter.length == 0) this.fetchData(this.activeTab);
    },
    searchFor() {
      if (this.filter.length > 0) {
        this.fetchData(this.activeTab);
      } else {
        this.fetchData(this.activeTab);
      }
    },
    filterPage() {
      if (this.pageNo.length > 0) {
        this.params = `&page=${this.pageNo}`;
        this.fetchData(this.activeTab);
        this.currentPage = this.pageNo;
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async fetchData(txt) {
      let url = null;
      if (txt == "generated") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            diet_plan.diet_planUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          url = diet_plan.diet_planUrl + "?filter=" + txt;
        }
      } else if (txt == "not-generated") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            diet_plan.diet_planUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          url = diet_plan.diet_planUrl + "?filter=" + txt;
        }
      } else if (txt == "all") {
        console.log(txt, "txt");
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          console.log("inside if**");
          url =
            diet_plan.diet_planUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          console.log("inside else**");
          url = diet_plan.diet_planUrl + "?filter=" + txt;
        }
      }
      url += this.params;
      this.$store.commit("loader/updateStatus", true);
      try {
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.tableData = responseData;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
      this.key += 1;
    },

    async fetchDietPlan(id) {
      this.$store.commit("loader/updateStatus", true);
      let url = diet_plan.diet_planUrl + "/" + id;
      const data = await this.getRequest(url);
      if (data.status) {
        const responseData = data.response;
        this.diet_plan_id = responseData.id;

        if (responseData.html != "" && responseData.html != null) {
          this.form.html = responseData.html;
        }

        this.edit.html = responseData.html;

        this.oldForm = _.clone(this.form);
      }

      this.$store.commit("loader/updateStatus", false);
    },
    cleanHTML(html) {
      return html
        .replace(/<div><br><\/div>/g, "")
        .replace(/<div>\s*<\/div>/g, "")
        .replace(/<p><br><\/p>/g, "")
        .replace(/&nbsp;/g, " ");
    },

    onEdit() {
      let cleaned = this.cleanHTML(this.$refs.editor.innerHTML);
      this.form.html = cleaned;
    },

    onTextareaEdit() {
      if (!this.isEditingPreview) {
        this.$refs.editor.innerHTML = this.form.html;
      }
    },

    async updateStatus(transaction) {
      console.log("Updating transaction:", transaction.id);

      this.loadingId = transaction.id;
      try {
        if (!transaction.id) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Transaction ID is required.",
          });
          this.loadingId = null;
          return;
        }

        const selectedLanguage =
          transaction.chat?.[0]?.question?.language || "english";

        // const dataArray = transaction.chat.map((item) => ({
        //   question: item.question?.question || "",
        //   answer: item.answer || "",
        // }));

        const dataArray = transaction.chat
          .map((item) => {
            let question = item.question?.question?.trim() || "";
            let answer = item.answer;

            // If answer is JSON string: "[\"Egg\"]"
            if (typeof answer === "string") {
              try {
                const parsed = JSON.parse(answer);
                if (Array.isArray(parsed)) {
                  answer = parsed.join(", ");
                }
              } catch (e) {
                answer = answer.trim();
              }
            }

            // If answer is actual array
            if (Array.isArray(answer)) {
              answer = answer.join(", ");
            }

            answer = (answer || "").trim();

            return { question, answer };
          })
          .filter((item) => item.question !== "" || item.answer !== "");

        const hasValidData = dataArray.some(
          (item) => item.question.trim() !== "" && item.answer.trim() !== ""
        );

        if (!hasValidData) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title:
              "Please provide at least one valid question and answer before generating the diet plan.",
          });
          this.loadingId = null;
          return; // 🚫 stop execution
        }

        const medicalReports = transaction.chat
          .flatMap((item) => item.file || [])
          .map((file) => file.trim())
          .filter(Boolean);

        const payload = {
          data: dataArray,
          medical_reports: medicalReports,
          language: selectedLanguage,
          transaction_id: transaction.id,
        };

        const url = diet_plan.updateStatus + "/" + transaction.id;
        const data = await this.postRequest(url, payload);

        if (data.status) {
          const index = this.tableData.data.findIndex(
            (e) => e.id === transaction.id
          );

          // ✅ Update both status and file_name (if returned)
          this.tableData.data[index].status = "created";
          this.tableData.data[index].file_name =
            data.response?.pdf_url || this.tableData.data[index].file_name;
          this.tableData.data[index].pdf_url =
            data.response?.pdf_url ?? this.tableData.data[index].file_name;

          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      } finally {
        this.loadingId = null;
      }
    },

    async generatePdf(record) {
      console.log("generating PDF:", record.id);

      try {
        const payload = {
          html: record.html,
          transaction_id: record.id,
        };

        console.log("PAYLOAD:", payload);

        const url = diet_plan.generatePdf;
        console.log("PDF URL:", url);

        const response = await this.postRequest(url, payload);
        console.log("Response wow:", response);

        if (response.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: response.message,
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      } finally {
        this.loadingId = null;
      }
    },

    async submitData() {
      try {
        this.submitted = true;
        this.$v.$touch();

        // default loader before API submit
        this.$store.commit("loader/updateStatus", {
          status: true,
          message: "Submitting data...",
        });

        let url = diet_plan.diet_planUrl + "/" + this.diet_plan_id;

        let dataAppend = new FormData();
        dataAppend.append("_method", "PATCH");
        if (this.form.html) dataAppend.append("html", this.form.html);

        const data = await this.postRequest(url, dataAppend);

        if (data.status) {
          // 🔥 Show loader while generating new PDF
          this.$store.commit("loader/updateStatus", {
            status: true,
            message: "Generating new plan...",
          });

          await this.generatePdf(data.response);

          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });

          this.$router.push("/diet-plan");
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    async fetchDiet_plan(id) {
      this.$store.commit("toast/updateStatus", true);
      try {
        let url = diet_plan.diet_planUrl + "/" + id;
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.diet_plan_id = responseData.id;
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Fetching error!",
        });
      }
      this.$store.commit("toast/updateStatus", false);
    },
    tabActive() {
      if (!this.can("edit-diet-plan")) {
        let index = this.fields.findIndex((item) => item.key == "edit");
        if (index !== -1) {
          this.fields.splice(index, 1);
          let table_index = this.table_header.findIndex(
            (item) => item == "edit"
          );
          this.table_header.splice(table_index, 1);
        }
      } else {
        if (!this.table_header.includes("edit")) {
          this.table_header.push("edit");
          this.fields[6] = {
            key: "edit",
          };
        }
      }
    },
    // async updateApproveStatus(id) {
    //   console.log(id, "id");
      
    //   try {
    //     let index = this.tableData.data.findIndex((e) => e.id === id);
    //     const url = diet_plan.updateApproveStatus + "/" + id;
    //     const data = await this.postRequest(url, {
    //       is_approved: !this.tableData.data[index].is_approved,
    //     });
    //     if (data.status) {
    //       const responseData = data.response;
    //       this.tableData.data[index] = responseData;
    //       this.$store.commit("toast/updateStatus", {
    //         status: true,
    //         icon: "success",
    //         title: data.message,
    //       });
    //     }
    //     this.key += 1;
    //   } catch (err) {
    //     this.$store.commit("toast/updateStatus", {
    //       status: true,
    //       icon: "error",
    //       title: err.data ? err.data.message : "Please try again!",
    //     });
    //   }
    // }, 
    async updateApproveStatus(id) {
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = diet_plan.updateApproveStatus + "/" + id;
    
        const newStatus =
          this.tableData.data[index].is_approved == 1 ? 0 : 1;
    
        const data = await this.postRequest(url, {
          is_approved: newStatus,
        });
    
        if (data.status) {
          this.tableData.data[index] = data.response;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
    
        this.key += 1;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
    },
    openModal(itemArray) {
      console.log("openModal:", itemArray);

      const fileItem = itemArray.find(i => i.file && i.file.length > 0);

      if (!fileItem) {
        this.imageFiles = [];
        this.pdfFiles = [];
        this.selectedFiles = [];
        this.$bvModal.show("document-modal");
        return;
      }

      // file is an array of URL strings
      this.selectedFiles = fileItem.file;
      this.imageFiles = this.selectedFiles.filter(f => this.isImage(f));
      this.pdfFiles = this.selectedFiles.filter(f => this.isPdf(f));

      this.$bvModal.show("document-modal");
    },

    openChatModal(itemArray) {
      this.chatList = itemArray;
      this.$bvModal.show("chat-modal");
    },

    formatAnswer(answer) {
      // If answer is null or empty return ''
      if (!answer) return '';
    
      // If answer is already an array
      if (Array.isArray(answer)) {
        return answer.join(", ");
      }
    
      // If answer is a JSON string array → parse it
      if (typeof answer === "string" && answer.startsWith("[") && answer.endsWith("]")) {
        try {
          const parsed = JSON.parse(answer); // Convert string to array
          if (Array.isArray(parsed)) {
            return parsed.join(", ");
          }
        } catch (e) {
          console.warn("JSON parse failed:", answer);
        }
      }
    
      // Otherwise return as string
      return answer;
    },    

    isImage(url) {
      console.log(url, "in isImage");
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
    },

    isPdf(url) {
      return /\.pdf$/i.test(url);
    },

    openFile(url) {
      window.open(url, "_blank");
    },
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (typeof value != undefined) {
          this.params = `&page=${value}`;
          this.fetchData(this.activeTab);
          this.pageNo = this.currentPage;
        }
      },
    },
    "form.html"(newVal) {
      if (!this.firstLoad && newVal) {
        this.$refs.editor.innerHTML = newVal;
        this.firstLoad = true;
      }
    },
    activeTab(v) {
      if (v) this.tabActive();
    },
  },
  mounted() {
    if (this.$route.name == "edit-diet-plan") {
      this.fetchDietPlan(this.$route.params.id);
    }
    this.tabActive();

    this.$refs.editor.innerHTML = this.form.html;
  },
  created() {
    this.fetchData(this.activeTab);
    this.fields.map((item) => {
      this.table_header.push(item.key);
    });
  },
};
